
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function DeityIndex() {
  return (
    <NonFSIndex
      data_type="deity"
      quick_fields={["pantheons","divine_domains","order","moral"]}
    />
  );
}
